import { useWide } from "../wide.ts";
import { IS_PANTRY } from "../brand.ts";

/**
 * The links under the tab "Bestand": stock, the day at a glance (on a phone; on a wide screen it
 * has its own tab), reports and the protocol. Stays at the top while the page scrolls.
 */
export function SubNav({ current }: { current: "bestand" | "uebersicht" | "auswertung" | "protokoll" | "fristen" }) {
  const wide = useWide();
  // VorratsBuch has no day overview and no reports in bottles (docs/18-vorratsbuch.md, V0-6).
  const items = IS_PANTRY
    ? ([["bestand", "Bestand"], ["fristen", "Fristen"], ["protokoll", "Logbuch"]] as const)
    : ([["bestand", "Bestand"], ...(wide ? [] : [["uebersicht", "Heute"]]), ["fristen", "Fristen"], ["auswertung", "Auswertung"], ["protokoll", "Logbuch"]] as const);
  return (
    <nav className="subnav" data-testid="subnav">
      {items.map(([route, label]) => (
        <a key={route} href={`#/${route}`} className={route === current ? "active" : ""} data-testid={`subnav-${route}`}>
          {label}
        </a>
      ))}
    </nav>
  );
}
